module.exports = __webpack_public_path__ + "img/Ellipse5.c89a7c17.png";